import * as types from './mutation-types';

const mutations = {
  [types.USER](state, user) {
    state.user = user;
  },
  [types.USER_GROUPS](state, groups) {
    state.userGroups = groups;
  },
  [types.SINGLE_USER](state, user) {
    state.singleUser = user;
  },
  [types.USER_PROFILE](state, userProfile) {
    state.userProfile = userProfile;
  },
  [types.DELETED_USER](state, deletedUser) {
    state.deletedUser = deletedUser;
  },
};

export default mutations;
